import React from "react";
import { Button, Modal } from "react-bootstrap";
import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import FormInputText from "src/components/Forms/FormInputText";
import { showValidationErrorToast } from "src/components/Toasts";
import axios from "src/config/axios";

const EditClosedPeriodDialog = ({
  closedPeriod,
  handleClose,
  handleSuccess,
}) => {
  const { t } = useTranslation("dashboard");

  function submit(values, helpers) {
    const request = closedPeriod.id
      ? axios.put(`/api/v1/closed_periods/${closedPeriod.id}.json`, {
          closed_period: values,
        })
      : axios.post("/api/v1/closed_periods.json", { closed_period: values });

    request
      .then(() => {
        helpers.setSubmitting(false);
        handleSuccess();
      })
      .catch((error) => {
        helpers.setErrors(error.response.data);
        helpers.setSubmitting(false);
        showValidationErrorToast(error);
      });
  }

  function validate(values) {
    const errors = {};

    if (!values.start_date) {
      errors.start_date = t(
        "settings.business.closed_periods.validation.required"
      );
    }

    if (!values.end_date) {
      errors.end_date = t(
        "settings.business.closed_periods.validation.required"
      );
    }

    if (
      values.start_date &&
      values.end_date &&
      values.start_date > values.end_date
    ) {
      errors.start_date = t(
        "settings.business.closed_periods.validation.end_before_start"
      );
    }

    return errors;
  }

  return (
    <Modal show={true} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>
          {t(
            closedPeriod.id
              ? "settings.business.closed_periods.edit_title"
              : "settings.business.closed_periods.create_title"
          )}
        </Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={{
          start_date: closedPeriod.start_date ?? "",
          end_date: closedPeriod.end_date ?? "",
        }}
        validate={validate}
        onSubmit={submit}
      >
        {({ isSubmitting }) => (
          <>
            <Modal.Body>
              <Form id="closed-period-form" autoComplete="off">
                <p className="text-muted">
                  {t("settings.business.closed_periods.description")}
                </p>
                <FormInputText
                  label={t("settings.business.closed_periods.start_date.label")}
                  name="start_date"
                  type="date"
                  required
                />
                <FormInputText
                  label={t("settings.business.closed_periods.end_date.label")}
                  name="end_date"
                  type="date"
                  required
                />
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                {t("common:components.button.close")}
              </Button>
              <Button
                variant="primary"
                type="submit"
                form="closed-period-form"
                disabled={isSubmitting}
              >
                {t("common:components.button.save")}
              </Button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </Modal>
  );
};

export default EditClosedPeriodDialog;
